import React from 'react';
import { Link } from '@mokoboko/components';

interface HowToBookInstructionsProps {
  onLoginClick: () => void;
}

const NumberedStep = ({
  number,
  children,
}: {
  number: number;
  children: React.ReactNode;
}) => (
  <li className="flex items-center gap-3.5">
    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-gray-100 text-xs font-semibold text-gray-900">
      {number}
    </span>
    <span className="text-sm leading-5 text-gray-700">{children}</span>
  </li>
);

export const HowToBookInstructions = ({
  onLoginClick,
}: HowToBookInstructionsProps) => {
  return (
    <div>
      <p className="text-base font-semibold text-gray-900">How to book classes</p>

      <ol className="mt-3 flex flex-col gap-3">
        <NumberedStep number={1}>
          <Link
            color="red"
            size="sm"
            onClick={onLoginClick}
            role="button"
            tabIndex={0}
          >
            Log in
          </Link>{' '}
          with your email
        </NumberedStep>
        <NumberedStep number={2}>No password needed</NumberedStep>
        <NumberedStep number={3}>
          Book any class and your credit auto-applies
        </NumberedStep>
        <NumberedStep number={4}>
          Manage your bookings from your account
        </NumberedStep>
      </ol>
    </div>
  );
};
